
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"84","height":"85","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.95 64.02L14.334 84.733l11.047-33.14L.525 32.26h30.379L41.95.5l11.047 31.76h30.379L58.521 51.592l11.047 33.141z","fill":"#F8C81C","fill-rule":"evenodd"}})])
          )
        }
      }
    